import type { NavigationItemType } from '@oppy/omniv2-core';

import NavigationItems from '../navigation-items';

type Props = {
  navigationItems?: NavigationItemType[];
  title?: string;
};

export default function SubNavigationItems({ navigationItems, title }: Props) {
  if (!navigationItems?.length) return null;

  return (
    <div data-testid="sub-nav-items" className="mt-10">
      <div className="mb-4 flex items-center gap-4 opacity-30">
        <div className="h-px w-full bg-base-text" />
        <div className="text-nowrap text-xs uppercase">{title}</div>
        <div className="h-px w-full bg-base-text" />
      </div>

      <NavigationItems isSubMenu navigationItems={navigationItems} />
    </div>
  );
}
